import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UsersComponent } from './components/users/users.component';
import { LoginComponent } from './components/login/login.component';
import { MainComponent } from './components/main/main.component';
import { AdminAuthGuard } from '@pulpo/pulpo-commons';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: MainComponent,
    canActivateChild: [AdminAuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'users',
        component: UsersComponent,
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./features/reporting/reporting.module').then(
            (m) => m.ReportingModule
          ),
      },
      {
        path: 'settings',
        component: SettingsComponent,
      },
      {
        path: 'groupes',
        loadChildren: () =>
          import('./features/groupes/groupes.module').then((m) => m.GroupesModule),
      },
      {
        path: 'minio',
        loadChildren: () =>
          import('./features/minio/minio.module').then((m) => m.MinioModule),
      },
      {
        path: 'flight-search',
        loadChildren: () =>
          import('./features/flight-search/flight-search.module').then(
            (m) => m.FlightSearchModule
          ),
      },
      { path: '**', redirectTo: 'home' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
